import { Link } from "react-router-dom";
import { Calendar, MapPin, Users, ArrowUpRight } from "lucide-react";
import { formatDate, formatCompensation } from "@/lib/api";
import { UrgentBadge } from "@/components/UrgentBadge";

export const EventCard = ({ e, index = 0, to }) => (
  <Link to={to || `/eventi/${e.id}`} className={`group block fade-up bg-[#121418] border ${e.is_urgent ? "border-[#E5484D]/40 hover:border-[#E5484D]/70" : "border-white/5 hover:border-[#D4AF37]/40"} transition-colors duration-500 p-7`} style={{ animationDelay: `${index * 60}ms` }} data-testid={`event-card-${e.id}`}>
    <div className="flex items-start justify-between gap-4">
      <span className="eyebrow">{e.category}</span>
      <div className="flex items-center gap-3">
        {e.is_urgent && <UrgentBadge testid={`event-card-urgent-${e.id}`} />}
        {e.status === "closed" && <span className="text-[10px] uppercase tracking-widest text-neutral-500 border border-white/10 px-2 py-0.5">Chiuso</span>}
        <ArrowUpRight className="w-4 h-4 text-neutral-600 group-hover:text-[#D4AF37] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-[transform,color] duration-300" />
      </div>
    </div>
    <h3 className="font-serif text-2xl mt-4 leading-snug">{e.title}</h3>
    <p className="text-xs text-neutral-500 mt-1">{e.client_name}</p>
    <div className="mt-6 grid grid-cols-2 gap-y-3 text-sm text-neutral-400">
      <span className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-[#D4AF37]" />{e.city}</span>
      <span className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-[#D4AF37]" />{formatDate(e.date)}</span>
      <span className="flex items-center gap-2"><Users className="w-3.5 h-3.5 text-[#D4AF37]" />{e.accepted_count}/{e.hostess_needed} selezionate</span>
      <span className="font-mono text-[#F9F8F6]">{formatCompensation(e)}</span>
    </div>
    <div className="mt-6 pt-4 border-t border-white/5 text-xs text-neutral-500 font-mono">{e.applicants_count} candidature</div>
  </Link>
);
